import { ref } from "vue";
import type { ConfirmationOptions } from "primevue/confirmationoptions";
import { useConfirm as usePrimeConfirm } from "primevue/useconfirm";

interface ConfirmEvent extends Event {
  group?: string;
}

export function useConfirm() {
  const primeConfirm = usePrimeConfirm();

  function confirm(event: ConfirmEvent) {
    const onAcceptRef = ref<(() => void) | null>(null);
    const onRejectRef = ref<(() => void) | null>(null);
    const targetElement = event.target as HTMLElement;

    const onAccept = (callback: () => void) => {
      onAcceptRef.value = callback;
    };

    const onReject = (callback: () => void) => {
      onRejectRef.value = callback;
    };

    let config: Partial<ConfirmationOptions> = {
      target: targetElement,
    };

    if (event.group) {
      config.group = event.group;
    }

    if (!event.group) {
      config = {
        ...config,
        message: "Are you sure you want to proceed?",
        icon: "pi pi-exclamation-triangle",
      };
    }

    primeConfirm.require({
      ...(config as ConfirmationOptions),
      accept: () => {
        if (onAcceptRef.value) {
          onAcceptRef.value();
        }
      },
      reject: () => {
        if (onRejectRef.value) {
          onRejectRef.value();
        }
      },
    });

    return { onAccept, onReject };
  }

  return { confirm };
}
